<template>
    <div :class="{ dark: isDarkMode }">
        <borderless-card-view class="zoom" :noBackground="true">
            <div>
                <div
                    class="d-flex flex-column card-base"
                    :class="{
                        'cover-height': event.coverPhotoUrl || event.emojiWallpaper,
                        'cover-image': event.coverPhotoUrl != null,
                        'cover-image-emoji': event.emojiWallpaper != null,
                    }"
                    :style="event.coverPhotoUrl == null ? { 'background-image': 'none' } : { 'background-image': `url(${event.coverPhotoUrl})` }"
                >
                    <emoji-wallpaper v-if="event.emojiWallpaper != null && event.emojiWallpaper != ''" class="emoji-background" :emoji="event.emojiWallpaper || ''" :emojiSize="30" :pixelsPerRow="60" :fixed="false" />
                    <div class="mt-auto z2">
                        <h4 v-if="event.coverPhotoUrl != null || event.emojiWallpaper != null" class="m-2 mx-4 card-title">
                            {{ event.name }}
                        </h4>
                        <h4 v-else class="m-1 mx-4 card-title-plain">
                            {{ event.name }}
                        </h4>
                    </div>
                    <div
                        class="card-bottom"
                        :class="{
                            'card-bottom-normal-blur': !event.emojiWallpaper,
                            'card-bottom-emoji-blur': event.emojiWallpaper,
                        }"
                    >
                        <div class="mx-3">
                            <div class="m-2 mb-3" :class="{ strikethrough: event.cancelled }">
                                {{ time() }}
                                <span> •</span>
                                <span v-if="!event.cancelled" class="myAtt ps-1"> {{ myAttendance() }}</span>
                                <b-badge variant="danger" v-else class="ms-2 p-2">Canceled</b-badge>
                            </div>
                        </div>
                    </div>
                </div>
                <calendar-box class="cal-box position-relative shadow-sm" :eventTime="event.time"></calendar-box>
            </div>
        </borderless-card-view>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from "vue";
import { PubEvent } from "@/data/Responses";
import dateFormat from "dateformat";
import Utils from "@/util/Utils";
import CalendarBox from "./CalendarBox.vue";
import EmojiWallpaper from "../components/EmojiWallpaper.vue";
import { useTheme } from "@/composables/useTheme";

export default defineComponent({
    components: { CalendarBox, EmojiWallpaper },
    name: "EventCard",
    mixins: [Utils],
    props: {
        event: { type: Object as PropType<PubEvent>, required: true },
    },
    setup() {
        const { isDarkMode } = useTheme();
        return { isDarkMode };
    },
    data() {
        return {};
    },
    methods: {
        myAttendance() {
            switch (this.event.myAttendance) {
                case "yes":
                    return "Going";
                case "no":
                    return "Can't go";
                case "maybe":
                    return "Maybe";
                case "unknown":
                    return "";
            }
        },

        time() {
            let date = new Date(this.event.time);
            return dateFormat(date, "shortTime");
        },
        date() {
            let date = new Date(this.event.time);
            return dateFormat(date, "fullDate");
        },
    },
});
</script>

<style scoped>
.strikethrough {
    text-decoration: line-through;
}

.event-details {
    position: relative;
    z-index: 2;
}

.card-base {
    min-height: 116px;
    background-color: var(--bg-secondary);
}

.cover-image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    display: flex;
    align-content: center;
}

.cover-height {
    height: 250px;
}

@media (min-width: 768px) {
    .cover-height {
        height: 300px;
    }
}

@media (min-width: 992px) {
    .cover-height {
        height: 350px;
    }
}

@media (min-width: 1200px) {
    .cover-height {
        height: 400px;
    }
}

.cover-image-emoji {
    position: relative;
    width: 100%;
    z-index: 0;
}

.emoji-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.card-title-plain {
    margin-bottom: 0;
    padding-left: 100px;
    font-weight: 500;
    font-size: 15pt;
}

.card-title {
    color: rgb(255, 255, 255);
    text-shadow: rgba(0, 0, 0, 0.8) 0em 0.05em 0.3em;
    font-weight: 700;
    font-size: 16pt;
    margin-bottom: 0;
    padding-left: 100px;
}

.z2 {
    z-index: 1;
}

.card-bottom {
    background-color: rgba(255, 255, 255, 0.85);
    color: var(--text-primary);
    padding-left: 100px;
}

.dark .card-bottom {
    background-color: hsla(0, 0%, 13%, 0.85);
}

/* The blur is kinda broken in chrome */
.card-bottom-emoji-blur {
    /* backdrop-filter: blur(10px); */
    z-index: 2;
}

.card-bottom-normal-blur {
    /* backdrop-filter: blur(50px); */
    z-index: 0;
}

.myAtt {
    font-weight: bold;
    color: var(--text-primary);
}

.cal-box {
    margin-top: -116px;
    position: inherit;
}

@media (max-width: 380px) {
    .cal-box {
        margin-top: -86px;
    }

    .card-bottom {
        padding-left: 70px;
    }

    .card-title {
        padding-left: 70px;
    }

    .card-title-plain {
        padding-left: 70px;
    }

    .card-base {
        min-height: 86px;
    }
}

a {
    text-decoration: none !important;
    color: var(--text-primary) !important;
}

a:link {
    text-decoration: none !important;
}

a:visited {
    text-decoration: none !important;
}

a:hover {
    text-decoration: inherit;
}

a:active {
    text-decoration: inherit;
}

.zoom {
    transition: transform 0.3s, box-shadow 0.3s;
}

.zoom:hover {
    box-shadow: 0 5px 1rem rgb(0 0 0 / 5%) !important;
    transform: scale(1.01);
}
</style>
